<template>
    <div class="products" data-aos="fade-right" :style="{
        position:top>height?'fixed':'absolute',
        top:top>height?'60px':defaultTop+'px',
    }">
        <el-menu
          :defaultActive="defaultActive"
          class="el-menu-vertical-demo "
          @select="handleSelect"
          >
          <el-menu-item v-for="(item,index) in productsList" :index="item.src"
                        :disabled="index===0
                        || index === 1
                        || index === 2
                        || index === 4
                        || index === 5
                        || index === 6
                        || index === 7
                        || index === 8
                        || index === 9
                        || index === 10
                        || index === 11
                        || index === 12
                        || index === 13
                        || index === 14
                        "
          >
              <span v-if="index!==0" v-html="item.title"></span>
              <div v-else>
                  <span v-html="item.title"></span>
                  <img :src="item.src" alt="" height="36px">
              </div>
          </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    data(){
      return {
        productsList:[
            {
              title:'EH-ILS实验室<br>整体规划设计解决方案',
              src:require('@/assets/tyLogo.png'),
            },
            {
              title:'eQuip<br>实验室耗材数字化管理系统',
              src:'/products/eQuip'
            },
            {
              title:'HazardHub危险化学品管理系统',
              src:'/products/proHazard'
            },
            {
              title:'iLab智慧实验室管理系统',
              src:'/products/iLab'
            },
            {
              title:'aniManus<br>动物实验室管理系统',
              src:'/products/aniManus'
            },
            {
              title:'EnviroMonitor<br>实验室温湿度监控系统',
              src:'/products/iMonitor'
            },
            {
              title:'Safeadom<br>实验室环境安全智慧管理系统',
              src:'/products/enViron'
            },
            {
              title:'labVision<br>实验室数字孪生大屏可视化系统',
              src:'/products/labVison'
            },
            // {
            //   title:'ISO15189咨询培训服务',
            //   src:'/products/iso15189'
            // },
            // {
            //   title:'CNAS咨询培训服务',
            //   src:'/products/cnas'
            // },
            // {
            //   title:'GLP咨询培训服务',
            //   src:'/products/glp'
            // },
            {
              title:'设备/耗材选型咨询服务',
              src:'/products/limsEquipment'
            },
            {
              title:'场地布局规划咨询',
              src:'/products/limsVenue'
            },
            {
              title:'实验室资料下载',
              src:'/products/limsDownload'
            },
        ],
        defaultActive:'/products/iLab',
        top:0,
        height:window.innerHeight + 120,
        defaultTop:-100
      }
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll, true)
        this.defaultActive = this.$route.path
    },
    methods:{
        handleScroll(){
          let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
          this.top = top
        },
        handleSelect(src){
            this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
.products{
    position: absolute;
    left: 10px;
    top: -180px;
    z-index: 999999;
    visibility: visible!important;
    .el-menu-vertical-demo{
        background: none;
        border-right: none;
        .el-menu-item{
            width: 320px;
            height: 60px;
            box-sizing: border-box;
            padding: 0!important;
            line-height: 60px;
            font-size: 16px;
            margin-bottom: 2px;
            background: #ededed;
            letter-spacing: 3px;
            text-align: left;
            &>span{
                display: flex;
                align-items: center;
                padding: 0px 0 0px 20px;
            }
            &:hover{
                background: #006efd;
                color: #fff;
                span{
                    color: #fff;
                }
            }
        }
        .el-menu-item:nth-child(2),.el-menu-item:nth-child(5),.el-menu-item:nth-child(6),.el-menu-item:nth-child(7),.el-menu-item:nth-child(8){
           span{
               line-height: 20px;
               padding: 10px 0 10px 20px;
            }
        }
        /*.el-menu-item:nth-child(1){*/
        /*   span{*/
        /*       line-height: 20px;*/
        /*       padding: 10px 0 10px 20px;*/
        /*    }*/
        /*}*/
        .el-menu-item:nth-child(1){
            cursor: auto;
            background: #ffe5e6!important;
            opacity: 1;
            &:hover{
                span{
                    color: #333;
                }
            }
            div{
                display: flex;
                justify-content: space-between;
                align-items: center;
                line-height: 25px;
                height: 100%;
                padding: 0 20px;
                span{
                    display: flex;
                    align-items: center;
                    height: 100%;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .is-active{
            background: #ed1c25;
            border-left: 5px solid #a50006;
            span{
                color: #fff;
            }
        }
    }
}

</style>
